(function() {
  window.adConfigs = window.adConfigs || {};

  const cravingImages = {
    'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Caramel-PDP.jpg?v=1775654171',
    'caramel2':     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Caramel_Craving_box_2_bars_PDP.png?v=1776270709',
    'caramel3':     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Caramel-3.png?v=1776271237',
    'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Peanut-PDP.jpg?v=1776242810',
    'peanutbutter2':'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_ad_outside_caramel_stretch.png?v=1775820938',
    'pistachio':    null,
    'raspberry':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_cropped.png?v=1774430529',
    'raspberry2':   'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_flat_lay_craving_PDP_image.png?v=1776083133',
    'raspberry3':   'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_Raspberry_3.png?v=1776243690',
    'raspberry4':   'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_smashed_craving_ad_ii.png?v=1776362170',
    'pretzel':      null,
    'smaltz':       null,
    'enrobingtrio': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self-Treat-Peanut-Butter-PDP.png?v=1775653052',
    'pistachioupclose': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Pistachio_smashed_up_close.png?v=1776689430',
    'raspberrysmashed': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_smashed_craving_ad.png?v=1776775888',
    'caramelfacingup': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Bar_facing_up_ad.png?v=1776849905',
    'caramelfacingupwithloop': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Caramel_pointing_up_with_loop.png?v=177737152',
    'raspberryfacingup': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_Raspberry_Bar_Pointing_Upwards.png?v=1777374872',
    'raspberryenrobingvideo': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_cropped.png?v=1774430529',
  };

  const cravingFlavours = {
    'caramel':      'Caramel',
    'caramel2':     'Caramel',
    'caramel3':     'Caramel',
    'peanutbutter': 'Peanut Butter',
    'peanutbutter2':'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'raspberry2':   'Raspberry',
    'raspberry3':   'Raspberry',
    'raspberry4':   'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt Cornflakes',
    'enrobingtrio': 'Peanut Butter',
    'pistachioupclose': 'Pistachio',
    'raspberrysmashed': 'Raspberry',
    'caramelfacingup': 'Caramel',
    'caramelfacingupwithloop': 'Caramel',
    'raspberryfacingup': 'Raspberry',
    'raspberryenrobingvideo': 'Raspberry',
  };

  const subtitle = 'Here we are';
  const socialProof = '★★★★★ Absolutely unreal bars';

  Object.entries(cravingFlavours).forEach(([key, displayName]) => {
    const pdpImage = cravingImages[key];

// No cart image change for build a box
    window.adConfigs[`craving-bab-${key}`] = {
      subtitle,
      heroImage: pdpImage,
      cartImage: null,
      socialProof,
      flavour: displayName,
    };
  });
})();